import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import LoginSVG from "../../utils/assets/mobile-login.svg";
import LoginSVGSM from "../../utils/assets/mobile-login-sm.svg";

import Profile from "../../utils/assets/profile.svg";
import Menu from "../../utils/assets/client/list.svg";
import "./client.css";
import { HandleLogout } from "../../actions/auth";

const Navbar = () => {
  const navigate = useNavigate();
  
  const TabLinks = [
    {
      id: 2435,
      title: "Dashboard",
      link: "/client",
    },
    {
      id: 6679,
      title: "Estimates",
      link: "/client/estimates",
    },
    {
      id: 1002,
      title: "Tickets",
      link: "/client/tickets",
    },
    {
      id: 1736,
      title: "Invoices",
      link: "/client/invoices",
    },
  ];
  const logoutUser = () => {
    localStorage.clear();
    navigate('/sign-in');
  }
 
  return (
    <>
      <nav className="navbar bg-black hide-nav-sm nav_position">
        <div className="container-fluid ">
          <a className="navbar-brand text-white" href="#">
            RMA Updates
          </a>
          <div className="me-auto mb-2 mb-lg-0 d-flex justify-content-center align-items-center">
            {TabLinks.map((item) => {
              return (
                <div
                  key={item.id}
                  className="nav-item mx-1"
                >
                  <NavLink
                    to={item.link}
                    className={({ isActive }) =>
                      `p-2 ${isActive ? "tab_link_active" : "tab_link"}`
                    }
                    end={item.link === "/client"}
                    aria-current="page"
                  >
                    {item.title}
                  </NavLink>
                </div>
              );
            })}
          </div>
          <div className="d-flex">
            <div onClick={logoutUser}
              className="p-0 m-0 text-white"
              style={{ fontSize: "18px" }}
            >
              <img width={30} src={LoginSVG} alt="login" />
            </div>
          </div>
        </div>
      </nav>
      <nav className="navbar bg-black hide-nav-lg nav_position">
        <div className="container-fluid ">
          <a className="navbar-brand text-white" href="#">
            RMA Updates
          </a>
          {/* <div className="me-auto mb-2 mb-lg-0 d-flex justify-content-center align-items-center">
            {TabLinks.map((item) => {
              return (
                <div
                  key={item.id}
                  className="nav-item"
                  onClick={() => handleClick(item.link)}
                >
                  <NavLink
                    to={item.link}
                    className={({ isActive }) =>
                      `p-2 ${isActive ? "tab_link_active" : "tab_link"}`
                    }
                    end={item.link === '/client'} 

                    aria-current="page"
                  >
                    {item.title}
                  </NavLink>{" "}
                </div>
              );
            })}
          </div> */}
          <div className="d-flex">
            <div
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#staticBackdrop"
              aria-controls="staticBackdrop"
            >
              <img width={30} src={Menu} alt="menu" />
            </div>
            <div
              className="offcanvas offcanvas-start"
              data-bs-backdrop="static"
              tabIndex={-1}
              id="staticBackdrop"
              aria-labelledby="staticBackdropLabel"
            >
              <div className="offcanvas-header bg-black">
                <h5
                  className="offcanvas-title text-white"
                  id="staticBackdropLabel"
                >
                  RMA Updates
                </h5>
                <button
                  type="button"
                  class="btn-close btn-close-white"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="offcanvas-body">
                <div className="d-flex flex-column">
                  {TabLinks.map((item) => {
                    return (
                      <>
                        <NavLink
                          to={item.link}
                          className={({ isActive }) =>
                            `p-2 ${isActive ? "tab_link_active_sm" : "tab_link_sm"}`
                          }
                          end={item.link === "/client"}
                          
                        >
                          <div
                          aria-current="page"
                          data-bs-dismiss="offcanvas"
                          >
                          {item.title}

                          </div>
                        </NavLink>
                        <hr className="my-1" />
                      </>
                    );
                  })}
                  <div
                    onClick={logoutUser}
                    className="p-0 m-0 text-white mt-2"
                    style={{ fontSize: "18px" }}
                  >
                    <img width={30} src={LoginSVGSM} alt="login" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;

// <nav className="navbar bg-body-tertiary bg-teal">
//     <div className="container-fluid flex justify-content-between align-items-center m-2">
//         <span className="navbar-brand mb-0 h1 text-white">Mac Repair Specialist</span>
//         <div className='mb-0 text-white'>
// <Link to="/sign-in" className='p-0 m-0 text-white' style={{fontSize: "18px"}}>
//     <img width={30} src={LoginSVG} alt="login" />
// </Link>
//         </div>
//     </div>
// </nav>
